// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ProfilingFilterBar specific styles */
.p-filter-bar {
  display: flex;
  align-items: center;
  padding: 14px 24px;
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
  justify-content: space-between;
  position: relative;
}

.add-profile-section,
.search-profile-section {
  display: flex;
  align-items: center;
  gap: 70px;
}

.p-main-content {
  margin-left: 280px;
  padding: 20px 30px;
}

.sidebar.collapsed + .p-main-content {
  margin-left: 100px; /* Adjusted for padding */
}

.p-filter-bar input[type="text"] {
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 8px;
  margin-right: 15px;
  flex: auto;
  width: 400px;
  font-size: 14px;
  transition: all 0.3s ease-in-out;
}

.p-filter-bar input[type="text"]:focus {
  border-color: #65ccb7;
  box-shadow: 0 0 5px rgba(101, 204, 183, 0.3);
}

#addProfile {
  padding: 12px 20px;
  background-color: #65ccb7;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.3s ease;
}

#addProfile:hover {
  background-color: #52b2a1;
}

.platform-btn,
.filter-btn {
  display: inline-block;
  padding: 10px 16px;
  background-color: #65ccb7;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  margin-right: 15px;
  vertical-align: middle;
  font-size: 14px;
  transition: all 0.3s ease;
}

.platform-btn:hover,
.filter-btn:hover {
  background-color: #52b2a1;
}

.fa-square-caret-down {
  margin-left: 8px;
}

.platform-options {
  top: calc(100% + 10px);
  left: 23%;
  background-color: white;
  padding: 12px;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  width: max-content;
  border-radius: 8px;
}

.p-filter-options {
  position: absolute;
  top: calc(100% + 10px);
  right: 0;
  background-color: white;
  border: 1px solid #ccc;
  border-radius: 8px;
  padding: 12px;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  width: max-content;
}

.line {
  width: 2px;
  height: 40px;
  background-color: #65ccb7;
  transform: translateX(-50%);
  margin-right: 10px;
  margin-left: 10px;
}

/* Style custom checkboxes */
.custom-checkbox {
  display: inline-block;
  width: 14px;
  height: 14px;
  background-color: white;
  border: 1px solid #65ccb7;
  border-radius: 4px;
  position: relative;
}

input[type="checkbox"] {
  opacity: 1;
  cursor: pointer;
  height: 15px;
  width: 15px;
}

.custom-checkbox::after {
  content: "";
  position: absolute;
  display: none;
  width: 5px;
  height: 10px;
  border: solid #65ccb7;
  border-width: 0px 2px 2px 0px;
  transform: rotate(45deg);
  left: 4px;
  bottom: 2.5px;
}

input[type="checkbox"]:checked + .custom-checkbox::after {
  display: block;
}

label {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.apply-filter {
  background-color: #65ccb7;
  color: white;
  border: none;
  border-radius: 5px;
  padding: 10px 20px;
  cursor: pointer;
  margin-left: 15px;
  font-size: 14px;
  transition: all 0.3s ease;
}

.apply-filter:hover {
  background-color: #52b2a1;
}

/* ProfilingCards specific styles */
.profiles-container {
  height: calc(83vh - 102px);
  overflow-y: auto;
  display: flex;
  flex-wrap: wrap;
  gap: 25px;
  justify-content: center;
  margin-top: 20px;
}

.profile-card {
  background-color: #ffffff;
  border-radius: 12px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  width: 350px;
  height: 380px;
  position: relative;
  transition: all 0.3s ease;
}

.profile-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.1);
}

.profile-card .p-color-strip {
  height: 100%;
  width: 10px;
  position: absolute;
  top: 0;
  left: 0;
  border-top-left-radius: 12px;
  border-bottom-left-radius: 12px;
}

.profile-card .profile-content {
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.profile-card .profile-content img {
  border-radius: 50%;
  width: 110px;
  height: 110px;
  margin-bottom: 15px;
  transition: transform 0.3s ease;
}

.profile-card .profile-content img:hover {
  transform: scale(1.1);
}

.profile-card .profile-content .username {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 8px;
}

.profile-card .profile-content .location {
  font-size: 14px;
  color: #707070;
  margin-bottom: 18px;
}

.profile-card .profile-content .stats {
  display: flex;
  justify-content: space-around;
  width: 100%;
  margin-top: 20px;
  font-size: 18px;
  font-weight: bold;
}

.profile-card .profile-content .stats-title {
  display: flex;
  justify-content: space-around;
  width: 100%;
  margin-bottom: 15px;
  align-items: center;
}

.profile-card .profile-content .stats .stat {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.profile-card .profile-content .actions {
  display: flex;
  justify-content: space-around;
  width: 100%;
  position: relative;
  margin-top: 20px;
}

.profile-card .profile-content .actions .action-btn {
  background: none;
  border: 2px solid;
  border-radius: 50%;
  cursor: pointer;
  padding: 12px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 55px;
  height: 55px;
  transition: all 0.3s ease;
}

.profile-card .profile-content .actions .action-btn.view-btn {
  color: #4c68f1;
  border-color: #4c68f1;
  
}

.profile-card .profile-content .actions .action-btn.update-btn {
  color: #f1b44c;
  border-color: #f1b44c;
}

.profile-card .profile-content .actions .action-btn.delete-btn {
  color: #d61a1a;
  border-color: #d61a1a;
}

.profile-card .profile-content .actions .action-btn:hover {
  transform: scale(1.1);
}

.profile-card .profile-content .actions .action-btn i {
  font-size: 22px;
}

.profile-card .profile-content .actions .hover-text {
  display: none;
  position: absolute;
  top: -7s;
  left: -6;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  color: white;
  font-weight: bold;
  padding: 8px;
}

.profile-card .profile-content .actions .action-btn:hover .hover-text {
  display: flex;
  z-index: 1;
}

.profile-card .profile-content .actions .hover-text.view-btn-hover {
  background-color: #4c68f1;
}

.profile-card .profile-content .actions .hover-text.update-btn-hover {
  background-color: #f1b44c;
}

.profile-card .profile-content .actions .hover-text.delete-btn-hover {
  background-color: #d61a1a;
}

.confirm-box {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: white;
  border: 1px solid #ccc;
  border-radius: 8px;
  padding: 25px 30px;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  text-align: center;
  width: 350px;
}

.confirm-box .confirm-content {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.confirm-box .confirm-content p {
  margin-bottom: 25px;
  font-size: 16px;
}

.confirm-box .confirm-content .confirm-btn {
  background-color: #65ccb7;
  color: white;
  border: none;
  border-radius: 5px;
  padding: 10px 20px;
  cursor: pointer;
  font-size: 16px;
  transition: background-color 0.3s ease;
}

.confirm-box .confirm-content .confirm-btn:hover {
  background-color: #52b2a1;
}

.profiles-container::-webkit-scrollbar {
  width: 8px;
}

.profiles-container::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.profiles-container::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 10px;
}

.profiles-container::-webkit-scrollbar-thumb:hover {
  background: #555;
}
`, "",{"version":3,"sources":["webpack://./src/profiling/profiling.css"],"names":[],"mappings":"AAAA,uCAAuC;AACvC;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,wCAAwC;EACxC,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB,EAAE,yBAAyB;AAC/C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,SAAS;EACT,uBAAuB;EACvB,aAAa;EACb,0CAA0C;EAC1C,aAAa;EACb,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,QAAQ;EACR,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,0CAA0C;EAC1C,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,yBAAyB;EACzB,2BAA2B;EAC3B,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,4BAA4B;AAC5B;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,UAAU;EACV,YAAY;EACZ,qBAAqB;EACrB,6BAA6B;EAC7B,wBAAwB;EACxB,SAAS;EACT,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,mCAAmC;AACnC;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,SAAS;EACT,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,wCAAwC;EACxC,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,WAAW;EACX,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,qBAAqB;;AAEvB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,0CAA0C;EAC1C,aAAa;EACb,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":["/* ProfilingFilterBar specific styles */\r\n.p-filter-bar {\r\n  display: flex;\r\n  align-items: center;\r\n  padding: 14px 24px;\r\n  background-color: #ffffff;\r\n  border-radius: 8px;\r\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\r\n  margin-bottom: 20px;\r\n  justify-content: space-between;\r\n  position: relative;\r\n}\r\n\r\n.add-profile-section,\r\n.search-profile-section {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 70px;\r\n}\r\n\r\n.p-main-content {\r\n  margin-left: 280px;\r\n  padding: 20px 30px;\r\n}\r\n\r\n.sidebar.collapsed + .p-main-content {\r\n  margin-left: 100px; /* Adjusted for padding */\r\n}\r\n\r\n.p-filter-bar input[type=\"text\"] {\r\n  padding: 10px;\r\n  border: 1px solid #ccc;\r\n  border-radius: 8px;\r\n  margin-right: 15px;\r\n  flex: auto;\r\n  width: 400px;\r\n  font-size: 14px;\r\n  transition: all 0.3s ease-in-out;\r\n}\r\n\r\n.p-filter-bar input[type=\"text\"]:focus {\r\n  border-color: #65ccb7;\r\n  box-shadow: 0 0 5px rgba(101, 204, 183, 0.3);\r\n}\r\n\r\n#addProfile {\r\n  padding: 12px 20px;\r\n  background-color: #65ccb7;\r\n  color: white;\r\n  border: none;\r\n  border-radius: 5px;\r\n  cursor: pointer;\r\n  font-size: 14px;\r\n  transition: background-color 0.3s ease;\r\n}\r\n\r\n#addProfile:hover {\r\n  background-color: #52b2a1;\r\n}\r\n\r\n.platform-btn,\r\n.filter-btn {\r\n  display: inline-block;\r\n  padding: 10px 16px;\r\n  background-color: #65ccb7;\r\n  color: white;\r\n  border: none;\r\n  border-radius: 5px;\r\n  cursor: pointer;\r\n  margin-right: 15px;\r\n  vertical-align: middle;\r\n  font-size: 14px;\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n.platform-btn:hover,\r\n.filter-btn:hover {\r\n  background-color: #52b2a1;\r\n}\r\n\r\n.fa-square-caret-down {\r\n  margin-left: 8px;\r\n}\r\n\r\n.platform-options {\r\n  top: calc(100% + 10px);\r\n  left: 23%;\r\n  background-color: white;\r\n  padding: 12px;\r\n  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);\r\n  z-index: 1000;\r\n  width: max-content;\r\n  border-radius: 8px;\r\n}\r\n\r\n.p-filter-options {\r\n  position: absolute;\r\n  top: calc(100% + 10px);\r\n  right: 0;\r\n  background-color: white;\r\n  border: 1px solid #ccc;\r\n  border-radius: 8px;\r\n  padding: 12px;\r\n  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);\r\n  z-index: 1000;\r\n  width: max-content;\r\n}\r\n\r\n.line {\r\n  width: 2px;\r\n  height: 40px;\r\n  background-color: #65ccb7;\r\n  transform: translateX(-50%);\r\n  margin-right: 10px;\r\n  margin-left: 10px;\r\n}\r\n\r\n/* Style custom checkboxes */\r\n.custom-checkbox {\r\n  display: inline-block;\r\n  width: 14px;\r\n  height: 14px;\r\n  background-color: white;\r\n  border: 1px solid #65ccb7;\r\n  border-radius: 4px;\r\n  position: relative;\r\n}\r\n\r\ninput[type=\"checkbox\"] {\r\n  opacity: 1;\r\n  cursor: pointer;\r\n  height: 15px;\r\n  width: 15px;\r\n}\r\n\r\n.custom-checkbox::after {\r\n  content: \"\";\r\n  position: absolute;\r\n  display: none;\r\n  width: 5px;\r\n  height: 10px;\r\n  border: solid #65ccb7;\r\n  border-width: 0px 2px 2px 0px;\r\n  transform: rotate(45deg);\r\n  left: 4px;\r\n  bottom: 2.5px;\r\n}\r\n\r\ninput[type=\"checkbox\"]:checked + .custom-checkbox::after {\r\n  display: block;\r\n}\r\n\r\nlabel {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n}\r\n\r\n.apply-filter {\r\n  background-color: #65ccb7;\r\n  color: white;\r\n  border: none;\r\n  border-radius: 5px;\r\n  padding: 10px 20px;\r\n  cursor: pointer;\r\n  margin-left: 15px;\r\n  font-size: 14px;\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n.apply-filter:hover {\r\n  background-color: #52b2a1;\r\n}\r\n\r\n/* ProfilingCards specific styles */\r\n.profiles-container {\r\n  height: calc(83vh - 102px);\r\n  overflow-y: auto;\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 25px;\r\n  justify-content: center;\r\n  margin-top: 20px;\r\n}\r\n\r\n.profile-card {\r\n  background-color: #ffffff;\r\n  border-radius: 12px;\r\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\r\n  width: 350px;\r\n  height: 380px;\r\n  position: relative;\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n.profile-card:hover {\r\n  transform: translateY(-5px);\r\n  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.profile-card .p-color-strip {\r\n  height: 100%;\r\n  width: 10px;\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  border-top-left-radius: 12px;\r\n  border-bottom-left-radius: 12px;\r\n}\r\n\r\n.profile-card .profile-content {\r\n  padding: 20px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  text-align: center;\r\n}\r\n\r\n.profile-card .profile-content img {\r\n  border-radius: 50%;\r\n  width: 110px;\r\n  height: 110px;\r\n  margin-bottom: 15px;\r\n  transition: transform 0.3s ease;\r\n}\r\n\r\n.profile-card .profile-content img:hover {\r\n  transform: scale(1.1);\r\n}\r\n\r\n.profile-card .profile-content .username {\r\n  font-size: 20px;\r\n  font-weight: bold;\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.profile-card .profile-content .location {\r\n  font-size: 14px;\r\n  color: #707070;\r\n  margin-bottom: 18px;\r\n}\r\n\r\n.profile-card .profile-content .stats {\r\n  display: flex;\r\n  justify-content: space-around;\r\n  width: 100%;\r\n  margin-top: 20px;\r\n  font-size: 18px;\r\n  font-weight: bold;\r\n}\r\n\r\n.profile-card .profile-content .stats-title {\r\n  display: flex;\r\n  justify-content: space-around;\r\n  width: 100%;\r\n  margin-bottom: 15px;\r\n  align-items: center;\r\n}\r\n\r\n.profile-card .profile-content .stats .stat {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n}\r\n\r\n.profile-card .profile-content .actions {\r\n  display: flex;\r\n  justify-content: space-around;\r\n  width: 100%;\r\n  position: relative;\r\n  margin-top: 20px;\r\n}\r\n\r\n.profile-card .profile-content .actions .action-btn {\r\n  background: none;\r\n  border: 2px solid;\r\n  border-radius: 50%;\r\n  cursor: pointer;\r\n  padding: 12px;\r\n  position: relative;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 55px;\r\n  height: 55px;\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n.profile-card .profile-content .actions .action-btn.view-btn {\r\n  color: #4c68f1;\r\n  border-color: #4c68f1;\r\n  \r\n}\r\n\r\n.profile-card .profile-content .actions .action-btn.update-btn {\r\n  color: #f1b44c;\r\n  border-color: #f1b44c;\r\n}\r\n\r\n.profile-card .profile-content .actions .action-btn.delete-btn {\r\n  color: #d61a1a;\r\n  border-color: #d61a1a;\r\n}\r\n\r\n.profile-card .profile-content .actions .action-btn:hover {\r\n  transform: scale(1.1);\r\n}\r\n\r\n.profile-card .profile-content .actions .action-btn i {\r\n  font-size: 22px;\r\n}\r\n\r\n.profile-card .profile-content .actions .hover-text {\r\n  display: none;\r\n  position: absolute;\r\n  top: -7s;\r\n  left: -6;\r\n  width: 100%;\r\n  height: 100%;\r\n  align-items: center;\r\n  justify-content: center;\r\n  border-radius: 4px;\r\n  color: white;\r\n  font-weight: bold;\r\n  padding: 8px;\r\n}\r\n\r\n.profile-card .profile-content .actions .action-btn:hover .hover-text {\r\n  display: flex;\r\n  z-index: 1;\r\n}\r\n\r\n.profile-card .profile-content .actions .hover-text.view-btn-hover {\r\n  background-color: #4c68f1;\r\n}\r\n\r\n.profile-card .profile-content .actions .hover-text.update-btn-hover {\r\n  background-color: #f1b44c;\r\n}\r\n\r\n.profile-card .profile-content .actions .hover-text.delete-btn-hover {\r\n  background-color: #d61a1a;\r\n}\r\n\r\n.confirm-box {\r\n  position: fixed;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n  background-color: white;\r\n  border: 1px solid #ccc;\r\n  border-radius: 8px;\r\n  padding: 25px 30px;\r\n  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);\r\n  z-index: 1000;\r\n  text-align: center;\r\n  width: 350px;\r\n}\r\n\r\n.confirm-box .confirm-content {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n}\r\n\r\n.confirm-box .confirm-content p {\r\n  margin-bottom: 25px;\r\n  font-size: 16px;\r\n}\r\n\r\n.confirm-box .confirm-content .confirm-btn {\r\n  background-color: #65ccb7;\r\n  color: white;\r\n  border: none;\r\n  border-radius: 5px;\r\n  padding: 10px 20px;\r\n  cursor: pointer;\r\n  font-size: 16px;\r\n  transition: background-color 0.3s ease;\r\n}\r\n\r\n.confirm-box .confirm-content .confirm-btn:hover {\r\n  background-color: #52b2a1;\r\n}\r\n\r\n.profiles-container::-webkit-scrollbar {\r\n  width: 8px;\r\n}\r\n\r\n.profiles-container::-webkit-scrollbar-track {\r\n  background: #f1f1f1;\r\n}\r\n\r\n.profiles-container::-webkit-scrollbar-thumb {\r\n  background: #888;\r\n  border-radius: 10px;\r\n}\r\n\r\n.profiles-container::-webkit-scrollbar-thumb:hover {\r\n  background: #555;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
